MOVE.HeroImages = (function(MOVE) {
  "use strict";
  var init = function(options) {
    var heroImages = $(options.target);
    // owl carousel
    heroImages.owlCarousel({
      lazyLoad: options.lazyLoad,
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 11000,
      animateOut: options.effect
    }); // /owlCarousel

  }; // /init closing brackets

  MOVE.HeroImages = {
    init: init
  };

  return MOVE.HeroImages;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/hero_images.js